<template>
    <button
        type="button"
        @click="handlerBuy"
        class="def-buy-component"
        :class="{ 'def-buy-component__not-available': !isAvailable }"
    >
        <slot v-if="isAvailable && inBasket(id)" name="inBasket" />
        <slot v-if="isAvailable && !inBasket(id)" />
        <slot v-if="!isAvailable" name="notAvailable" />
    </button>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

// import ECommerceSend from "../../../utils/ECommerceSend";
export default {
    name: 'DefBuy',
    selector: '.def-buy',
    props: ['result', 'disabled'],
    data() {
        return {
            isRequestSend: false,
        }
    },
    computed: {
        ...mapState({
            createOrder: ({ basket }) => basket.data?.routes?.createOrder,
        }),
        ...mapGetters({
            inBasket: 'basket/inBasket',
        }),
        id() {
            return this.result?.offer?.id || this.result?.id;
        },
        isAvailable() {
            return this.result?.offer?.isAvailable || this.result?.isAvailable;
        },
    },
    methods: {
        ...mapMutations({
            changeOpenSmallBasket: 'basket/changeOpenSmallBasket'
        }),
        ...mapActions({
            add: 'basket/add',
        }),
        async handlerBuy() {
            // if (!this.inBasket(this.id)) {
                this.isRequestSend = true;
                await this.add({ id: this.id });
                // ECommerceSend.buy(this.result.dataLayerProduct);
                // App.helpers.scrollPageTo(0);
                this.isRequestSend = false;
            // } else {
            //     this.changeOpenSmallBasket(true);
            // }
        },
    },
    mounted() {
        // setTimeout(this.createAnimation,1000)
    }
}
</script>

<style lang="scss" scoped>
.def-buy-component{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background-color: transparent;
    border: 2px solid #000;
    font-weight: 600;
    font-size: rem(10);
    line-height: 100%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    transition: .2s linear background-color;
    padding: 0 15px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    border-radius: rem(8);
    &:hover{
        background-color: #3c3d41;
        color: white;
    }
    &__not-available {
        background-color: grey;
        border-color: grey;
        color: white;
        pointer-events: none;
        /*color: var(--color-dark-grey);*/
    }
    //&:disabled{
    //    border-color: var(--border-grey);
    //    pointer-events: none;
    //    color: #5F5F67;
    //}
}
</style>